var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import { nanoid } from "nanoid";
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import { EMutualFundOrderTabs, } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
import ClientNamesWithClientCodes from "../ClientNamesWithClientCodes/ClientNamesWithClientCodes";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
import { Spinner } from "react-bootstrap";
import MandateOrderStatusFilters from "../MandateOrderFilters/MandateOrderStatusFilters/MandateOrderStatusFilters";
import MandateTypeFilters from "../MandateOrderFilters/MandateTypeFilters/MandateTypeFilters";
var SummaryFilters = function (props) {
    var currentSelectedTransactionTab = props.currentSelectedTransactionTab, allTransactionsDataFromRedux = props.allTransactionsDataFromRedux, SIP_SWP_STP_DataFromRedux = props.SIP_SWP_STP_DataFromRedux, filtersData = props.filtersData, mandateFilterData = props.mandateFilterData, clientNamesFilterDisplayData = props.clientNamesFilterDisplayData;
    // *******************************************
    // *           useStates                     *
    // *******************************************
    var _a = __read(React.useState(undefined), 2), localAllTransactionFilters = _a[0], setLocalAllTransactionFilters = _a[1];
    var _b = __read(React.useState(undefined), 2), localSIP_STP_SWP_TransactionFilters = _b[0], setLocalSIP_STP_SWP_TransactionFilters = _b[1];
    var _c = __read(React.useState([]), 2), localClientsList = _c[0], setLocalClientsList = _c[1];
    var _d = __read(React.useState(""), 2), searchedClient = _d[0], setSearchedClient = _d[1];
    var _e = __read(React.useState([]), 2), filterTabs = _e[0], setFilterTabs = _e[1];
    var _f = __read(React.useState("orderStatus"), 2), activeTabKey = _f[0], setActiveTabKey = _f[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var generateCheckboxFiltersForStatus = function (filtersData, selectedDataArr) {
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            React.createElement("div", { className: "d-flex justify-content-end orderbook-summary-select-all-filters-btn-container" },
                React.createElement(EdButton, { btnTyp: "text-only", value: (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length) > 1 ? "Deselect All" : "Select All", className: "text-right p-10 txt-han-blue orderbook-summary-select-all-filters-btn DMsanL_12_300", onClick: function () {
                        var _a, _b, _c, _d;
                        return handleSelectAllOrderStatus((selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length) > 1 &&
                            (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length) <
                                ((_b = (_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList) === null || _b === void 0 ? void 0 : _b.length)
                            ? true
                            : ((_d = (_c = handleChooseDataFromReduxForOperation()) === null || _c === void 0 ? void 0 : _c.tranSummaryList) === null || _d === void 0 ? void 0 : _d.length) === (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length));
                    } })),
            React.createElement("div", null, filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.includes(item.status),
                        value: item.status,
                        onChange: function (e) { return handleCheckboxChange(e); },
                    }, labelProps: {
                        children: item.status,
                        className: "DMsanL_12_300",
                    } }));
            }))));
    };
    var generateRadioFiltersForClients = function (filtersData, selectedDataArr) {
        return (React.createElement("div", { className: "client-names-radio-filters-container" },
            React.createElement(FundSearchPanel, { placeholder: "Search by client name", applySearchedFilters: handleSearchClientsInFilters, searchValue: searchedClient }),
            React.createElement("div", { className: "d-flex flex-column" }, (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) ? (filtersData.map(function (item) {
                return (React.createElement(RadioButton, { key: nanoid(), list: {
                        display: (React.createElement(ClientNamesWithClientCodes, { clientName: item === null || item === void 0 ? void 0 : item.clientName, clientCode: item === null || item === void 0 ? void 0 : item.accountCode, wrapClientName: true })),
                        value: item === null || item === void 0 ? void 0 : item.accountCode,
                    }, selected: (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length) ? selectedDataArr[0] : "", name: "", onChange: function (e) { return handleRadioChange(e); } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateFiltersLoaderOrErrorUI = function (loader, dataForFilterFunction, filterUIGeneratorFunction) {
        if (loader) {
            return (React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100" },
                React.createElement(Spinner, { animation: "border", variant: "primary" })));
        }
        else {
            return (dataForFilterFunction === null || dataForFilterFunction === void 0 ? void 0 : dataForFilterFunction.length) ? (filterUIGeneratorFunction()) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!" }));
        }
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleSelectAllOrderStatus = function (areAllSelected) {
        var _a, _b;
        var dataToReturn = undefined;
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var updatedFilters = __assign({}, localAllTransactionFilters);
                    updatedFilters.status = [];
                    if (!areAllSelected) {
                        updatedFilters.status =
                            (_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList.map(function (item) { return item.status; });
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalAllTransactionFilters(updatedFilters);
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var updatedFilters = __assign({}, localSIP_STP_SWP_TransactionFilters);
                    updatedFilters.status = [];
                    if (!areAllSelected) {
                        updatedFilters.status =
                            (_b = handleChooseDataFromReduxForOperation()) === null || _b === void 0 ? void 0 : _b.tranSummaryList.map(function (item) { return item.status; });
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalSIP_STP_SWP_TransactionFilters(updatedFilters);
                }
                break;
        }
        !!props.handleFilterChangeCallback &&
            props.handleFilterChangeCallback(dataToReturn);
    };
    var handleCheckboxChange = React.useCallback(function (e) {
        var _a, _b, _c, _d;
        var dataToReturn = undefined;
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var updatedFilters = __assign({}, localAllTransactionFilters);
                    if (e.target.checked) {
                        (_a = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.status) === null || _a === void 0 ? void 0 : _a.push(e.target.value);
                    }
                    else {
                        updatedFilters.status = (_b = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.status) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item !== e.target.value; });
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalAllTransactionFilters(updatedFilters);
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var updatedFilters = __assign({}, localSIP_STP_SWP_TransactionFilters);
                    if (e.target.checked) {
                        (_c = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.status) === null || _c === void 0 ? void 0 : _c.push(e.target.value);
                    }
                    else {
                        updatedFilters.status = (_d = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.status) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item !== e.target.value; });
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalSIP_STP_SWP_TransactionFilters(updatedFilters);
                }
                break;
            case EMutualFundOrderTabs.MANDATES:
                break;
        }
        !!props.handleFilterChangeCallback &&
            props.handleFilterChangeCallback(dataToReturn);
    }, [localAllTransactionFilters, localSIP_STP_SWP_TransactionFilters]);
    var handleRadioChange = function (e) {
        var _a, _b;
        var dataToReturn = undefined;
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var updatedFilters = __assign({}, localAllTransactionFilters);
                    if (!((_a = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.clientCodes) === null || _a === void 0 ? void 0 : _a.includes(e.target.value))) {
                        updatedFilters.clientCodes = [];
                        updatedFilters.clientCodes.push(e.target.value);
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalAllTransactionFilters(updatedFilters);
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var updatedFilters = __assign({}, localSIP_STP_SWP_TransactionFilters);
                    if (!((_b = updatedFilters === null || updatedFilters === void 0 ? void 0 : updatedFilters.clientCodes) === null || _b === void 0 ? void 0 : _b.includes(e.target.value))) {
                        updatedFilters.clientCodes = [];
                        updatedFilters.clientCodes.push(e.target.value);
                    }
                    dataToReturn = __assign({}, updatedFilters);
                    setLocalSIP_STP_SWP_TransactionFilters(updatedFilters);
                }
                break;
            default:
                break;
        }
        !!props.handleFilterChangeCallback &&
            props.handleFilterChangeCallback(dataToReturn);
    };
    var handleUpdateFiltersRespectiveToTab = function () {
        var _a, _b;
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var localFilterTabs = [
                        {
                            title: "Order Status",
                            eventKey: "orderStatus",
                            tabContent: generateFiltersLoaderOrErrorUI(props.allTransactionsFiltersLoader, (_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList, function () {
                                var _a;
                                return generateCheckboxFiltersForStatus((_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList, filtersData === null || filtersData === void 0 ? void 0 : filtersData.status);
                            }),
                            // tabContent: allTransactionsDataFromRedux?.tranSummaryList
                            //   ?.length ? (
                            //   generateCheckboxFiltersForStatus(
                            //     allTransactionsDataFromRedux?.tranSummaryList,
                            //     filtersData?.status
                            //   )
                            // ) : (
                            //   <BasicErrorMessage />
                            // ),
                        },
                        {
                            title: "Client Name",
                            eventKey: "clientName",
                            tabContent: generateFiltersLoaderOrErrorUI(props.clientNamesFiltersLoader, clientNamesFilterDisplayData, function () {
                                return generateRadioFiltersForClients(localClientsList, filtersData === null || filtersData === void 0 ? void 0 : filtersData.clientCodes);
                            }),
                        },
                    ];
                    handleUpdateFilterTabsData(localFilterTabs);
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var localFilterTabs = [
                        {
                            title: "Order Status",
                            eventKey: "orderStatus",
                            tabContent: generateFiltersLoaderOrErrorUI(props.SIP_STP_SWP_FiltersLoader, (_b = handleChooseDataFromReduxForOperation()) === null || _b === void 0 ? void 0 : _b.tranSummaryList, function () {
                                var _a;
                                return generateCheckboxFiltersForStatus((_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList, filtersData === null || filtersData === void 0 ? void 0 : filtersData.status);
                            }),
                        },
                        {
                            title: "Client Name",
                            eventKey: "clientName",
                            tabContent: generateFiltersLoaderOrErrorUI(props.clientNamesFiltersLoader, clientNamesFilterDisplayData, function () {
                                return generateRadioFiltersForClients(localClientsList, filtersData === null || filtersData === void 0 ? void 0 : filtersData.clientCodes);
                            }),
                        },
                    ];
                    handleUpdateFilterTabsData(localFilterTabs);
                }
                break;
            case EMutualFundOrderTabs.MANDATES:
                {
                    var localFilterTabs = [
                        {
                            title: "Order Status",
                            eventKey: "orderStatus",
                            tabContent: (React.createElement(MandateOrderStatusFilters, { handleFilterChangeCallback: props === null || props === void 0 ? void 0 : props.handleUpdateMandateFilterData, selectedFiltersData: mandateFilterData })),
                        },
                        {
                            title: "Mandate Type",
                            eventKey: "mandateType",
                            tabContent: (React.createElement(MandateTypeFilters, { handleFilterChangeCallback: props === null || props === void 0 ? void 0 : props.handleUpdateMandateFilterData, selectedFiltersData: mandateFilterData })),
                        },
                    ];
                    handleUpdateFilterTabsData(localFilterTabs);
                }
                break;
            default:
                break;
        }
    };
    var handleUpdateFilterTabsData = function (data) {
        setFilterTabs(function () { return data; });
    };
    var handleApplyFilters = React.useCallback(function () {
        var dataToReturn = { transactionsStatusData: [], clientsData: [] };
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    dataToReturn = {
                        transactionsStatusData: allTransactionsDataFromRedux.tranSummaryList,
                        clientsData: clientNamesFilterDisplayData,
                    };
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    dataToReturn = {
                        transactionsStatusData: SIP_SWP_STP_DataFromRedux.tranSummaryList,
                        clientsData: clientNamesFilterDisplayData,
                    };
                }
                break;
            case EMutualFundOrderTabs.MANDATES:
                (props === null || props === void 0 ? void 0 : props.handleApplyMandateFilters) &&
                    (props === null || props === void 0 ? void 0 : props.handleApplyMandateFilters(mandateFilterData));
                break;
            default:
                break;
        }
        !(props === null || props === void 0 ? void 0 : props.handleApplyMandateFilters) &&
            !!(props === null || props === void 0 ? void 0 : props.handleApplyCallback) &&
            props.handleApplyCallback(filtersData, dataToReturn);
    }, [
        filtersData,
        allTransactionsDataFromRedux,
        SIP_SWP_STP_DataFromRedux,
        mandateFilterData,
        clientNamesFilterDisplayData,
    ]);
    var handleSearchClientsInFilters = function (searchedText) {
        setSearchedClient(searchedText);
        var localSearchedClientResult = [];
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                localSearchedClientResult = clientNamesFilterDisplayData === null || clientNamesFilterDisplayData === void 0 ? void 0 : clientNamesFilterDisplayData.filter(function (item) {
                    return item.clientName.toLowerCase().includes(searchedText.toLowerCase());
                });
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                localSearchedClientResult = clientNamesFilterDisplayData === null || clientNamesFilterDisplayData === void 0 ? void 0 : clientNamesFilterDisplayData.filter(function (item) {
                    return item.clientName.toLowerCase().includes(searchedText.toLowerCase());
                });
                break;
            default:
                break;
        }
        setLocalClientsList(localSearchedClientResult);
    };
    var handleUpdateRespectiveFilterState = function () {
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                setLocalAllTransactionFilters(filtersData);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                setLocalSIP_STP_SWP_TransactionFilters(filtersData);
                break;
            default:
                break;
        }
    };
    var handleUpdateLocalClientsListRespectiveToTab = function () {
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                setLocalClientsList(function () { return clientNamesFilterDisplayData; });
                // setLocalClientsList(() => allTransactionsDataFromRedux?.clientCodeList);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                setLocalClientsList(function () { return clientNamesFilterDisplayData; });
                // setLocalClientsList(() => SIP_SWP_STP_DataFromRedux?.clientCodeList);
                break;
            default:
                setLocalClientsList([]);
                break;
        }
    };
    var handleChooseDataFromReduxForOperation = function () {
        switch (currentSelectedTransactionTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                return allTransactionsDataFromRedux;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                return SIP_SWP_STP_DataFromRedux;
        }
    };
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    React.useEffect(function () {
        handleUpdateFiltersRespectiveToTab();
    }, [
        currentSelectedTransactionTab,
        filtersData,
        localClientsList,
        props === null || props === void 0 ? void 0 : props.allTransactionsFiltersLoader,
        props === null || props === void 0 ? void 0 : props.SIP_STP_SWP_FiltersLoader,
        mandateFilterData,
    ]);
    React.useEffect(function () {
        handleUpdateRespectiveFilterState();
    }, [filtersData]);
    React.useEffect(function () {
        handleUpdateLocalClientsListRespectiveToTab();
    }, [
        activeTabKey,
        currentSelectedTransactionTab,
        clientNamesFilterDisplayData,
        // allTransactionsDataFromRedux?.clientCodeList,
        // SIP_SWP_STP_DataFromRedux?.clientCodeList,
    ]);
    return (React.createElement(VerticalFilterTabs, { defaultActiveKey: activeTabKey, handleTabChange: function (key) { return setActiveTabKey(key); }, tabsList: filterTabs, cancelBtnCallback: props === null || props === void 0 ? void 0 : props.handleCancelCallback, applyBtnCallback: function () { return handleApplyFilters(); }, clearAllBtnCallback: props === null || props === void 0 ? void 0 : props.handleClearAllCallback }));
};
export default SummaryFilters;
